import React from "react";
import styles from "../../styles";
import { inputStyles } from "./style.js";
import { UUID } from "../../utils.js";

const Line = ({ index, id, value, style, onKeyDown, onChange, modifiable }) => {
  if (modifiable)
    return (
      <div
        contentEditable={true}
        className={id + "_line"}
        data-index={index}
        type="text"
        spellCheck={false}
        style={{ ...inputStyles.lineInput, ...style }}
        onKeyDown={onKeyDown}
        onInput={onChange}
      />
    );
  else
    return (
      <div
        className={id + "_line"}
        data-index={index}
        type="text"
        spellCheck={false}
        style={{ ...inputStyles.lineInput, ...style }}
      >
        {value}
      </div>
    );
};

class ConsoleEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lineNumber: 0,
      lines: [{ value: "" }],
    };
    this.id = UUID();
    this.lineOnChange = this.lineOnChange.bind(this);
    this.lineOnKeyDown = this.lineOnKeyDown.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.consoleOptions = {
      cls: () => {
        this.setState((state) => ({
          ...state,
          lineNumber: 0,
          lines: [{ value: "" }],
        }));
      },
    };
  }

  componentDidMount() {
    if (Array.isArray(this.props.lines) && this.props.lines.length > 0)
      this.setState((state) => ({
        ...state,
        lines: this.props.lines,
      }));
  }

  lineOnChange(e) {
    const value = e.target.innerText;
    const lines = this.state.lines;
    const index = Number(e.target.dataset.index);
    lines[index].value = value;
    this.setState((state) => ({
      ...state,
      lines,
      lineNumber: lines.length - 1,
    }));
  }

  setFocus(index) {
    const lines = document.getElementsByClassName(this.id + "_line");
    setTimeout(() => lines[index].focus(), 0);
  }

  lineOnKeyDown(e) {
    const key = e.key;
    const target = e.target;
    const lines = this.state.lines;
    const value = target.innerText;
    const outputHead = "<<< ";
    if (key === "Enter") {
      e.preventDefault();
      if (value in this.consoleOptions) {
        this.consoleOptions[value]();
        return;
      }
      const result = this.props.evalFunc(value);
      if (result.length !== 0) {
        for (let res of result) {
          lines.push({
            value: outputHead + res,
          });
        }
        lines.push({ value: "" });
      } else {
        lines.push({ value: "" });
      }
      this.setState(
        (state) => ({
          ...state,
          lines,
          lineNumber: lines.length - 1,
        }),
        () => {
          this.setFocus(lines.length - 1);
        }
      );
    } else if (key === "ArrowUp") {
      e.preventDefault();
    }
  }

  render() {
    const lines = this.state.lines;
    const inputLines = lines.map((line, index) => {
      if (index === this.state.lineNumber) {
        return (
          <Line
            index={index}
            key={index}
            id={this.id}
            value={line.value}
            modifiable={true}
            style={{
              background: "black",
              minHeight: 20,
              fontSize: 15,
              fontFamily: "roboto",
              color: "lightgreen",
              paddingLeft: 5,
            }}
            onKeyDown={this.lineOnKeyDown}
            onChange={this.lineOnChange}
          />
        );
      } else {
        return (
          <Line
            index={index}
            key={index}
            id={this.id}
            value={line.value}
            modifiable={false}
            style={{
              background: "black",
              minHeight: 20,
              fontSize: 15,
              fontFamily: "roboto",
              color: "green",
              paddingLeft: 5,
            }}
            onKeyDown={this.lineOnKeyDown}
            onChange={this.lineOnChange}
          />
        );
      }
    });
    return (
      <div
        style={{
          ...styles.row,
          ...inputStyles.window,
          height: this.props.height,
          width: this.props.width,
          background: "grey",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            ...inputStyles.frame,
            background: "grey",
          }}
        >
          {inputLines}
        </div>
      </div>
    );
  }
}

export default ConsoleEditor;
